import React, { FunctionComponent } from 'react'
import { Heading, Text, GridWall, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { useAllowedShippingOptions, useIsDisabledUpdatingCheckout, useIsShippingOptionAddressError, useShippingOption } from '../../state'
import { useCheckoutSizes } from '../../utils/responsive'
import styles from './style.module.css'
import { useSummaryHeaderLabel, useSummarySubtextLabel } from './hooks'
import { useCheckoutColor } from '../../utils/color'
import { ShippingOption, ShippingOptionStatus } from '../../model'

interface Props {
  selectedShippingOption?: ShippingOption
}

export const ShippingOptionHeader: FunctionComponent<Props> = ({ selectedShippingOption }) => {
  const { shippingOptionsStatus } = useShippingOption()
  const isShippingAddressError = useIsShippingOptionAddressError()
  const isDisabled = useIsDisabledUpdatingCheckout()
  const { headingTextColor, subtextColor } = useCheckoutColor({ isDisabled: isDisabled || isShippingAddressError })
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { smallTextSize, textSize, sectionHeadingSize } = useCheckoutSizes()
  const allowedShippingOptions = useAllowedShippingOptions()

  const isShippingOptionLoading = shippingOptionsStatus <= ShippingOptionStatus.Loading
  const hasAllowedShippingOptions = !(allowedShippingOptions.length === 0 && !isShippingOptionLoading)

  const summaryHeadingLabel = useSummaryHeaderLabel(hasAllowedShippingOptions, selectedShippingOption)
  const summarySubtextLabel = useSummarySubtextLabel(selectedShippingOption)

  const selectedShippingOptionName = selectedShippingOption?.name

  const renderSummaryHeader = (): JSX.Element => {
    if (isArcadeDesignLanguage) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Text color={headingTextColor} size={textSize} bold>
            {summaryHeadingLabel}
          </Text>
          <Text color={subtextColor} size={smallTextSize}>
            {summarySubtextLabel}
          </Text>
        </div>
      )
    }

    return (
      <GridWall columns={2} gutter='none'>
        <Heading size={sectionHeadingSize}>{summaryHeadingLabel}</Heading>
        {shippingOptionsStatus !== ShippingOptionStatus.Error && (
          <span className={styles.selectedShippingOption}>
            <Text size={textSize} renderAs='span'>
              {selectedShippingOptionName}
            </Text>
          </span>
        )}
      </GridWall>
    )
  }

  return <>{renderSummaryHeader()}</>
}
